import { Text } from './Text';
import { IconClose } from '@/components/icons';
import { colors } from '@/theme/tokens';
import styles from './ErrorBanner.module.css';

interface ErrorBannerProps {
  message: string | null;
  onDismiss?: () => void;
}

/**
 * Shown when a transaction could not be recorded.
 *
 * Deliberately loud and deliberately not auto-dismissing: this is the one
 * message the shopkeeper must not miss, because the sale did not happen.
 */
export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  if (!message) return null;

  return (
    <div className={styles.banner} role="alert">
      <Text weight={700} size={12.5} color={colors.surfaceAlt} className="grow">
        {message}
      </Text>
      {onDismiss ? (
        <button type="button" aria-label="ປິດ" onClick={onDismiss} className={styles.close}>
          <IconClose size={16} />
        </button>
      ) : null}
    </div>
  );
}
